module.exports = __webpack_public_path__ + "img/button-group-dark-01.bfd240e8.png";